import { Col, Form, Input, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaRegCopy } from "react-icons/fa";

const BillingInformation = ({ company, form }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (company) {
      form.setFieldsValue({
        ...company,
      });
    }
  }, [company, form]);

  const handleCopyData = () => {
    const billingValues = form.getFieldsValue([
      "billingStreet",
      "billingCity",
      "billingZipCode",
      "billingState",
      "billingCountry",
    ]);

    form.setFieldsValue({
      shippingStreet: billingValues.billingStreet,
      shippingCity: billingValues.billingCity,
      shippingZipCode: billingValues.billingZipCode,
      shippingState: billingValues.billingState,
      shippingCountry: billingValues.billingCountry,
    });
  };
  return (
    <>
      {/* <Form layout="vertical"> */}
      {/* Billing Details */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label={t("common.address", "Address") + " (" + t("company.street", "Street") + ")"} name="billingStreet">
            <Input placeholder={t("company.street")} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={t("common.address", "Address") + " (" + t("company.city", "City") + ")"} name="billingCity">
            <Input placeholder={t("company.city")} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label={t("company.billingZipCode")} name="billingZipCode">
            <Input placeholder={t("company.zipCode")} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={t("company.billingState")} name="billingState">
            <Input placeholder={t("company.state")} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label={t("company.billingCountry")} name="billingCountry">
            <Input placeholder={t("company.country")} />
          </Form.Item>
        </Col>
      </Row>
      {/* Shipping Details hidden as requested */}
      {/* </Form> */}
    </>
  );
};

export default BillingInformation;
